import objectFitImages from 'object-fit-images'
import 'url-search-params-polyfill'
import '@webcomponents/custom-elements'
import ready from 'ready'

ready(function() { objectFitImages() })
